/**
 * Loads a translation asset bundle from /public/language_assets/{locale}/{taskPrefix}.asset.json
 * Returns null when English is selected or file is not found — callers fall back to DB text.
 */
const cache = new Map();

export const loadTranslationBundle = async (locale, taskPrefix) => {
  if (!locale || locale === 'en' || !taskPrefix) return null;

  const cacheKey = `${locale}/${taskPrefix}`;
  if (cache.has(cacheKey)) return cache.get(cacheKey);

  const path = `/language_assets/${locale}/${taskPrefix}.asset.json`;
  try {
    const response = await fetch(path);
    if (!response.ok) {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`[Translation] Asset not found: ${path}`);
      }
      cache.set(cacheKey, null);
      return null;
    }
    const bundle = await response.json();
    cache.set(cacheKey, bundle);
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Translation] Loaded: ${path} (${Object.keys(bundle.entries || {}).length} entries)`);
    }
    return bundle;
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[Translation] Failed to load ${path}:`, err.message);
    }
    cache.set(cacheKey, null);
    return null;
  }
};

export const clearTranslationCache = () => cache.clear();
